import React from "react";

import { AiFillStar } from "react-icons/ai";

import "./TestemonileBlock.scss";
const TestemonileBlock = (props) => {
  return (
    <>
      <div className="testemonileBlock">
        <div className="testemonile_head">
          <div className="head">
            <div className="img">
              <img src={props.img} alt="testemonileimg"></img>
            </div>
            <div className="title">
              <h5>{props.title}</h5>
              <span>{props.date}</span>
            </div>
          </div>
          <div className="stars">
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
          </div>
        </div>
        <p>{props.description}</p>
      </div>
    </>
  );
};

export default TestemonileBlock;
